<template>
  <section class="relative z-10 py-10 sm:py-12 md:py-14 lg:py-16 xl:py-20">
    <slot />
  </section>
</template>
